// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"e71f5097c61119604eef","6980":"a3ae023dd193b5a7ba38"}[chunkId] + ".js";
};